import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next'

import { useCopyViewMutation } from '@redux/api'

import { ENTITY, ENTITY_PATH, ROUTES } from '@constants'

import {
  ConfigRowsType,
  CopyModelDataType,
  DataOfCopiedModelType,
  ViewShortDTO,
} from '../../../types'
import { deleteEntityType, deleteViewByCodeType } from '../types'

type useHandlersParams = {
  deleteView: deleteEntityType
  deleteViewByCode: deleteViewByCodeType
  type: ENTITY
}

export const useHandlers = ({ deleteView, deleteViewByCode, type }: useHandlersParams) => {
  const navigate = useNavigate()
  const [objectCode, setObjectCode] = useState<string>()
  const [searchPattern, setSearchPattern] = useState<string>()
  const [currentTab, setCurrentTab] = useState(0)
  const [isDirty, setDirty] = useState(false)
  const [allEntities, setAllEntities] = useState<ViewShortDTO[]>([])
  const [showCopyDialog, setShowCopyDialog] = useState(false)
  const [copyViewData, setCopyViewData] = useState<DataOfCopiedModelType | null>(null)
  const [copyEntity, { isLoading: isLoadingCopyEntity }] = useCopyViewMutation()

  const handleDeleteEntity = (id: string | number) => deleteView(id)

  // TODO привести удаление к одному методу
  const handleDeleteEntityByCode = (code: string) => deleteViewByCode(code)

  const handleEditEntity = (code: string) => {
    navigate(
      `${ROUTES[`CONFIG_${ENTITY_PATH[type]}_EDIT` as keyof typeof ROUTES] as string}/${code}`
    )
  }

  const handleSetObjectCode = (code: string) => setObjectCode(code)

  const handleSetSearchPattern = (pattern: string) => {
    setSearchPattern(pattern)
  }

  const handleTabChange = (value: number) => {
    if (isDirty && confirm(t('notifications.leave'))) {
      setCurrentTab(value)
      setDirty(false)

      return
    }

    if (!isDirty) {
      setCurrentTab(value)
    }
  }

  const handleSetDirty = (value: boolean) => setDirty(value)

  const handleSetAllEntities = (value: ConfigRowsType[]) => setAllEntities(value)

  const handleShowDialog = (data: ConfigRowsType) => {
    const { id, objectCode, title, objectTitle } = data

    setCopyViewData({ id, objectCode, title, objectTitle })
    setShowCopyDialog(true)
  }

  const handleCloseDialog = () => {
    setCopyViewData(null)
    setShowCopyDialog(false)
  }

  const handleCopyEntity = (data: CopyModelDataType) => {
    const { code, title, copyId } = data
    copyEntity({ code, title, id: copyId })
      .unwrap()
      .then(res => {
        setShowCopyDialog(false)

        navigate(`${ROUTES[`CONFIG_${ENTITY_PATH[type]}_EDIT` as keyof typeof ROUTES]}/${res.code}`)
      })
  }

  return {
    state: {
      objectCode,
      searchPattern,
      currentTab,
      isDirty,
      allEntities,
      showCopyDialog,
      copyViewData,
      isLoadingCopyEntity,
    },
    data: {},
    handlers: {
      handleDeleteEntity,
      handleDeleteEntityByCode,
      handleCopyEntity,
      handleEditEntity,
      handleSetObjectCode,
      handleSetSearchPattern,
      handleSetDirty,
      handleSetAllEntities,
      handleTabChange,
      handleShowDialog,
      handleCloseDialog,
    },
  }
}
